import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import templateMarkup from 'raw-loader!./flexipanel-widget.html';
import LogiCommon from "../../../app/data-framework/logi-common";
import ClickThruService from "../../../services/clickthru.service";
import DataProvider from "../../../app/data-framework/data-provider";

var AREA_TREND = 'Area Trend';
var STACKED_AREA_TREND = 'Stacked Area Trend';
var BAR = 'Bar';
var BAR_TREND = 'Bar Trend';
var LINE_TREND = 'Line Trend';
var PIE = 'Pie';
var TABLE = 'Table';
var TREND = 'Trend';

function FlexiPanelWidget(params) {
    var self = this;
    self.dataProvider = DataProvider.getInstance();
    self.observableData = params.observableData;
    self.observableOptions = params.observableOptions;
    self.observableParamsList = params.observableParamsList;
    self.panelTemplate = params.panelTemplate;
    self.resizeSignal = params.resizeSignal;
    self.viewLevelOptions = params.viewLevelOptions;
    self.widgetSignals = params.widgetSignals;
    self.isCapacityView = Boolean(_.get(ko.unwrap(params.viewLevelOptions), 'isCapacityView'));

    self.logiCommon = new LogiCommon();

    if (!self.widgetSignals().resizeSignal) {
        self.widgetSignals().resizeSignal = params.resizeSignal;
    }

    self.id1 = 1;
    self.id2 = 2;
    self.id3 = 3;
    self.id4 = 4;
    self.subscriptions = [];
    self.loadMode = true;
    self.panelHeaderHeight = 60;
    self.selectedCount = 10;

    self.declareAndInitializeObservables();

    if (!self.tableVisible() && !self.widgetSignals().reflowSignal) {
        self.widgetSignals().reflowSignal = params.reflowSignal;
    }

    if (self.timeGrainVisible()) {
        self.panelHeaderHeight += 5;
    }

    self.getSelectedMetric = function () {
        var metric = self.selectedMetricColumn();

        if (!metric) {
            return null;
        }

        var allmetrics = self.metricColumns();

        var selectedMetric = $.grep(allmetrics,
            function (met) {
                return met.columnKey === metric;
            });

        if (!_.isEmpty(selectedMetric)) {
            return selectedMetric[0];
        }

        return null;
    };

    self.setAggregation = function () {
        var selmetric = self.getSelectedMetric();

        if (selmetric && selmetric.aggregateFunction) {
            self.selectedAggregation(selmetric.aggregateFunction);
        }
    };

    self.clickCallback = function (e1) {
        var options = ko.unwrap(self.observableOptions);

        if (!e1.point.total && e1.point.series && e1.point.series.data[e1.point.index] && e1.point.series.data[e1.point.index].y === 0) {
            return;
        }

        var date;
        var start;
        var end;

        if (e1.point.x && (moment.utc(e1.point.x).isValid()) && (moment.utc(e1.point.x).isAfter('2000-01-01T00:00:00Z'))) {
            date = moment.utc(e1.point.x);

            start = date
                .startOf('day')
                .format('YYYY-MM-DD');

            end = date
                .endOf('day')
                .add(1, self.selectedTimeGrain() + 's')
                .subtract(1, 'days')
                .format('YYYY-MM-DD');

        } else {
            start = self.viewLevelOptions().inpStartDate.replace(/\//g, '-');
            end = self.viewLevelOptions().inpEndDate.replace(/\//g, '-');
        }

        var filterval;
        if (e1.point.name) {
            filterval = e1.point.name;
        } else {
            filterval = e1.point.series.name;
        }
        filterval = _.unescape(filterval);

        let notin = _.toLower(filterval).startsWith('all others');
        let notinFilterval = '';
        if (notin) {
            // We add notin in clause for all others
                let cols = $.map(options.type === TREND ? e1.point.series.chart.series : e1.point.series.data, function (gitem) {
                if (!_.toLower(gitem.name) !== 'all others' && _.toLower(gitem.name) !== 'all others (average)') {
                    return gitem.name;
                }
            });
            notinFilterval = cols.join();
        }

        ClickThruService.clickThru(options.type,
            self.selectedMetricColumn(), self.selectedGroupColumn(), options.selectedCategory,
            options.whereConditionObj,
            date, start, end,
            notin ? notinFilterval : filterval, notin,
            self.allFilterColumns);

    };

    self.saveOptions = function () {

        var options = ko.unwrap(self.observableOptions);
        if( !_.isEqual(options.selectedMetricColumnNames, [self.selectedMetricColumn()]) ||
            !_.isEqual(options.selectedGroupColumnNames, [self.selectedGroupColumn()]) ||
            !_.isEqual(options.selectedAggregations, [self.selectedAggregation()]) ||
            !_.isEqual(options.selectedDisplayType, self.selectedDisplayType()) ||
            !_.isEqual(options.selectedTimeGrain, self.selectedTimeGrain()) ||
            !_.isEqual(options.selectedDatasetNames,[self.selectedDataset()]) ||
            !_.isEqual(options.selectedEndpointTags, self.selectedEndpointTags())) {
                options.selectedMetricColumnNames = [self.selectedMetricColumn()];
                options.selectedGroupColumnNames = [self.selectedGroupColumn()];
                options.selectedAggregations = [self.selectedAggregation()];
                options.selectedDisplayType = self.selectedDisplayType();
                options.selectedTimeGrain = self.selectedTimeGrain();
                options.selectedDatasetNames = [self.selectedDataset()];
                options.selectedEndpointTags = self.selectedEndpointTags();

                if (options.type === TREND && options.selectedDisplayType !== TABLE) {
                    options = self.fixTrendSorting(options);
                }
                self.observableOptions(options);
        }
    };

    self.loadOptions = function () {
        var options = ko.unwrap(self.observableOptions);

        if (!_.isEmpty(options.selectedMetricColumnNames)) {
            var metric = options.selectedMetricColumnNames[0];
            try {
                metric = metric.toLowerCase();
            } catch (ex) {
            }
            self.selectedMetricColumn(metric);
        }

        if (!_.isEmpty(options.selectedGroupColumnNames)) {
            var group = options.selectedGroupColumnNames[0];
            try {
                group = group.toLowerCase();
            } catch (ex) {
            }
            self.selectedGroupColumn(group);
        }

        if (!_.isEmpty(options.selectedAggregations)) {
            self.selectedAggregation(options.selectedAggregations[0]);
        }

        self.setAggregation();  // if metric has aggregatefunction, use that instead of saved.

        if (options.selectedDisplayType) {
            self.selectedDisplayType(options.selectedDisplayType);
        }

        if (options.selectedDaysPerWeek) {
            self.selectedDaysPerWeek(options.selectedDaysPerWeek);
        }

        if (options.selectedHoursPerDay) {
            self.selectedHoursPerDay(options.selectedHoursPerDay);
        }

        if (options.selectedEPCategory) {
            self.selectedEPCategory(options.selectedEPCategory);
        }

        if (options.selectedVMRCategory) {
            self.selectedVMRCategory(options.selectedVMRCategory);
        }

        if (options.selectedSortOrder) {
            self.selectedSortOrder(options.selectedSortOrder);
        }

        if (options.selectedTimeGrain !== null) {
            self.selectedTimeGrain(options.selectedTimeGrain);
        }

        if (!_.isEmpty(options.selectedDatasetNames)) {
            self.selectedDataset(options.selectedDatasetNames[0]);
        }

        if (!_.isEmpty(options.selectedEndpointTags)) {
            self.selectedEndpointTags(options.selectedEndpointTags);
        }

        self.timeGrainVisible(!self.pieVisible());

        self.setVisibilities();

        self.loadMode = false;
    };

    self.fillGroups = function () {
        if (self.selectedMetricColumn() && self.allGroups) {

            var firstPartOfMetric = self.selectedMetricColumn().split('.')[0];

            var groups = $.grep(self.allGroups,
                function (grp) {
                    return grp.factKey.split('.')[0] === firstPartOfMetric;
                });

            groups.unshift({
                columnKey: '',
                columnName: '',
                columnDescription: '(no grouping)',
                columnDescriptionBy: '(no grouping)'
            });

            var groupkeys = $.map(groups,
                function (grpitem) {
                    return grpitem.columnKey;
                });

            if ($.inArray(self.selectedGroupColumn(), groupkeys) < 0) {
                self.selectedGroupColumn('');
            }

            self.groupColumns(groups);
        }

    };

    self.chartTypeClicked = function (data) {
        var options = ko.unwrap(self.observableOptions);
        if (_.includes(data.css, 'bar')) {
            self.selectedDisplayType(options.type === TREND ? BAR_TREND : BAR);
        } else if (_.includes(data.css, 'pie')) {
            self.selectedDisplayType(PIE);
        } else if (_.includes(data.css, 'line')) {
            self.selectedDisplayType(LINE_TREND);
        } else if (_.includes(data.css, 'area')) {
            self.selectedDisplayType(_.includes(data.css, 'far') ? STACKED_AREA_TREND : AREA_TREND);
        } else if (_.includes(data.css, 'table')) {
            self.selectedDisplayType(TABLE);
        }
    };

    self.dayClicked = function () {
        self.selectedTimeGrain('day');
        self.saveOptions();
        self.loadData();
    };

    self.weekClicked = function () {
        self.selectedTimeGrain('week');
        self.saveOptions();
        self.loadData();
    };

    self.monthClicked = function () {
        self.selectedTimeGrain('month');
        self.saveOptions();
        self.loadData();
    };

    self.quarterClicked = function () {
        self.selectedTimeGrain('quarter');
        self.saveOptions();
        self.loadData();
    };

    // run in case data is already set
    self.DataUpdated();

    self.subscriptions.push(
        self.observableData.subscribe(function (data) {
            if ((!self.allGroups && !_.isEmpty(data.metadata)) || !self.loadMode) {
                self.DataUpdated();
            }
        }),

        self.observableOptions.subscribe(function () {
            if (self.loadMode) {
                return;
            }
            if (self.widgetSignals && self.widgetSignals().optionsSignal) {
                self.widgetSignals().optionsSignal.dispatch(self.observableOptions());
            }

            self.OptionsUpdated();
        }),

        self.selectedDisplayType.subscribe(function () {
            if (self.loadMode) {
                return;
            }
            self.saveOptions();
            self.setVisibilities();
        })
    );

    self.subscriptions.push(
        self.selectedMetricColumn.subscribe(function () {
            if (self.loadMode) {
                return;
            }
            self.setAggregation();
            self.fillGroups();
            self.saveOptions();
        })
    );

    /**
     * Highcharts requires data to be pre-sorted in ascending X order for line or stock charts.
     * http://www.highcharts.com/errors/15
     * this will reset sortIndex and set ascending order
     */
    self.fixTrendSorting = function (options) {
        options.sortIndex = 0;
        options.sortAsc = true;
        return options;
    };

    self.loadData = function () {
        var options = ko.unwrap(self.observableOptions);

        if (!self.selectedDisplayType() || !self.viewLevelOptions()) {
            return;
        }

        if (self.datasetsVisible() && !self.selectedDataset()) {
            return;
        }

        if ((self.metricsVisible() && !self.selectedMetricColumn()) ||
            (self.groupsVisible() && !self.selectedAggregation())) {
            return;
        }

        if (self.widgetSignals && self.widgetSignals().dataRequested) {
            self.widgetSignals().dataRequested.dispatch();
        }

        var obsparams = self.observableParamsList[0]();

        obsparams.queryId = self.datasetsVisible()
            ? 'FlexAccessQueryWithMetadata'
            : 'FlexAccessQuery';

        var paramsTemp = self.viewLevelOptions();

        if (self.metricsVisible()) {
            paramsTemp.aggregatefact = self.selectedAggregation() + '(' + self.selectedMetricColumn() + ')';
            paramsTemp.groupby = self.selectedGroupColumn();

        } else {
            paramsTemp.aggregatefact = '';
            paramsTemp.groupby = '';
        }

        if (options.additionalGroups) {
            paramsTemp.groupby = paramsTemp.groupby + options.additionalGroups;
        }

        let wco;
        let conjunction = self.observableOptions().whereConditionObj.conjunction || options.whereConditionConjunction || 'AND';
        if (!_.isEmpty(paramsTemp.WhereConditionObj)) {
            wco = paramsTemp.WhereConditionObj;
        } else {
            wco = self.observableOptions().whereConditionObj;
            paramsTemp.WhereConditionConjunction = conjunction;
        }

        paramsTemp.WhereCondition = ko.toJSON(wco);
        paramsTemp.WhereConditionConjunction = conjunction;
        paramsTemp.filter = '1=1';
        paramsTemp.timegrain = self.timeGrainVisible() ? self.selectedTimeGrain() : '';
        paramsTemp.tag = self.selectedEndpointTags().join(',');
        paramsTemp.dataset = self.datasetsVisible() ? self.selectedDataset() : '';
        paramsTemp.pageNum = self.datasetsVisible() ? self.observableOptions().pageNum : 1;
        paramsTemp.pageSize = self.datasetsVisible() ? self.observableOptions().pageSize : '';
        paramsTemp.sortIndex = self.observableOptions().sortIndex;

        paramsTemp.sortColumn = self.observableOptions().display
            ? self.observableOptions().display[paramsTemp.sortIndex]
            : '';

        if (!paramsTemp.sortColumn) {
            paramsTemp.sortColumn = self.observableOptions().displayDetail
                ? self.observableOptions().displayDetail[paramsTemp.sortIndex - 1]
                : '';
        }

        paramsTemp.hoursPerDay = self.selectedHoursPerDay();
        paramsTemp.daysPerWeek = self.selectedDaysPerWeek();

        var category = '';
        if (self.selectedDataset() === 'manageendpointdeltaxml') {
            category = self.selectedEPCategory();

        } else if (self.selectedDataset() === 'vmrdeltaxml') {
            category = self.selectedVMRCategory();
        }

        paramsTemp.csvParameter = 'count = 10,sort = ' + self.selectedSortOrder() + ',category = ' + category;

        var isDescendingOrder = (paramsTemp.sortColumn && (self.observableOptions().sortAsc === false));
        paramsTemp.sortColumn = paramsTemp.sortColumn + (isDescendingOrder ? ' DESC' : ' ASC');

        obsparams.paramsJson = ko.toJSON(paramsTemp);
        obsparams.panelId = options.id;

        self.observableParamsList[0](obsparams);
    };

    self.subscriptions.push(
        self.selectedGroupColumn.subscribe(function () {
            if (self.loadMode) {
                return;
            }
            self.saveOptions();
        }),

        self.selectedEndpointTags.subscribe(function () {
            if (self.loadMode) {
                return;
            }
            self.saveOptions();
        }),

        self.selectedDataset.subscribe(function () {
            if (self.loadMode) {
                return;
            }

            self.saveOptions();

        })
    );

    if (self.viewLevelOptions) {
        self.subscriptions.push(
            self.viewLevelOptions.subscribe(function (newval) {
                self.isCapacityView = newval ? newval.isCapacityView : false;
                if (self.loadMode) {
                    return;
                }
                self.loadData();
            })
        );
    }

    self.loadOptions();
    self.loadData();
}

FlexiPanelWidget.prototype = {
    declareAndInitializeObservables: function () {
        var self = this;

        self.aggregations = ko.observableArray(['Sum', 'Avg', 'Count']);
        self.datasets = ko.observableArray();
        self.endpointTags = ko.observableArray(['AUSTIN', 'US']);
        self.groupColumns = ko.observableArray();
        self.metricColumns = ko.observableArray();
        self.selectedAggregation = ko.observable('Sum');
        self.selectedDataset = ko.observable();
        self.selectedDaysPerWeek = ko.observable('');
        self.selectedDisplayType = ko.observable();
        self.selectedEndpointTags = ko.observableArray([]);
        self.selectedEPCategory = ko.observable('');
        self.selectedGroupColumn = ko.observable('');
        self.selectedHoursPerDay = ko.observable('');
        self.selectedMetricColumn = ko.observable();
        self.selectedSortOrder = ko.observable('');
        self.selectedTimeGrain = ko.observable('day');
        self.selectedVMRCategory = ko.observable('');
        self.timegrains = ko.observableArray(['day', 'week', 'month', 'quarter']);
        self.totalValue = ko.observable();

        self.tableVisible = ko.observable();
        self.pieVisible = ko.observable();
        self.barVisible = ko.observable();
        self.barTrendVisible = ko.observable();
        self.lineTrendVisible = ko.observable();
        self.areaTrendVisible = ko.observable();
        self.stackedAreaTrendVisible = ko.observable();
        self.datasetsVisible = ko.observable();
        self.metricsVisible = ko.observable();
        self.groupsVisible = ko.observable();
        self.timeGrainVisible = ko.observable();
        self.setVisibilities();

        self.chartType = ko.pureComputed(function () {
            var self = this;
            var chartType = '';
            if (ko.unwrap(self.pieVisible)) {
                chartType = 'pie';
            } else if (ko.unwrap(self.barVisible)) {
                chartType = 'bar';
            } else if (ko.unwrap(self.barTrendVisible)) {
                chartType = 'bartrend';
            } else if (ko.unwrap(self.lineTrendVisible)) {
                chartType = 'linetrend';
            } else if (ko.unwrap(self.areaTrendVisible)) {
                chartType = 'areatrend';
            } else if (ko.unwrap(self.stackedAreaTrendVisible)) {
                chartType = 'stackedareatrend';
            }
            return chartType;
        }, self);

        self.selectedDisplayIconClass = ko.pureComputed(function () {
            return getSelectedDisplayIconClass(ko.unwrap(self.selectedDisplayType));
        }, self);

        var options = ko.unwrap(self.observableOptions);
        self.displayIconClasses = ko.observableArray(getDisplayIconClasses(options.type));
    },

    RefreshData: function () {
        var self = this;

        var data = self.observableData();
        var options = ko.unwrap(self.observableOptions);

        if (!_.isEmpty(_.get(data, 'metadata'))) {
            if (!self.allGroups) {
                var flagname = self.isCapacityView ? 'capacityFlag' : 'otherFlag';

                var metrics = $.grep(data.metadata.Table, function (item) {
                    return item[flagname] === 1;
                });

                self.metricColumns(metrics);
                self.allGroups = $.extend(true, [], data.metadata.GroupCols);
                _.forEach(self.allGroups, function (grp) {
                    grp.columnDescriptionBy = 'by ' + grp.columnDescription;
                });
                self.allFilterColumns = $.extend(true, [], data.metadata.FilterCols);

                self.loadOptions();
                self.fillGroups();

                if (!_.isEmpty(_.get(options, 'selectedGroupColumnNames.0'))) {
                    self.selectedGroupColumn(_.toLower(options.selectedGroupColumnNames[0]));
                }
            }

            if (data.display && _.isEmpty(options.dispatch)) {
                options.display = $.extend([], data.display);
                self.loadMode = true;
                self.observableOptions(options);
                self.loadMode = false;
            }

        } else if (!self.datasetsLoaded) {
            if (!_.isEmpty(data)) {
                self.datasetsLoaded = true;
            }

            if (data.displayDetail && _.isEmpty(options.displayDetail)) {
                options.displayDetail = $.extend([], data.displayDetail);

                if (data.colOptionsDetail && _.isEmpty(options.colOptionsDetail)) {
                    options.colOptionsDetail = data.colOptionsDetail;
                }
                self.loadMode = true;
                self.observableOptions(options);
                self.loadMode = false;
            }
        }

        if (self.widgetSignals && self.widgetSignals().dataLoaded && !_.isEmpty(self.observableData())) {
            self.widgetSignals().dataLoaded.dispatch();
        }

    },

    DataUpdated: function () {
        var self = this;
        self.RefreshData();
    },

    OptionsUpdated: function () {
        var self = this;

        if (self.loadMode) {
            return;
        }

        self.loadMode = true;
        self.loadOptions();
        self.fillGroups();

        var options = ko.unwrap(self.observableOptions);

        if (!_.isEmpty(options.selectedGroupColumnNames)) {
            self.selectedGroupColumn(options.selectedGroupColumnNames[0]);
        }

        self.datasetsLoaded = false;
        options.colOptionsDetail = null;
        self.loadData();
    },

    setVisibilities: function () {
        var self = this;
        var options = ko.unwrap(self.observableOptions);
        self.tableVisible(self.selectedDisplayType() === TABLE);
        self.pieVisible(self.selectedDisplayType() === PIE);
        self.barVisible(self.selectedDisplayType() === BAR);
        self.barTrendVisible(self.selectedDisplayType() === BAR_TREND);
        self.lineTrendVisible(self.selectedDisplayType() === LINE_TREND);
        self.areaTrendVisible(self.selectedDisplayType() === AREA_TREND);
        self.stackedAreaTrendVisible(self.selectedDisplayType() === STACKED_AREA_TREND);
        self.timeGrainVisible(options.type === TREND);
        self.datasetsVisible(options.type === TABLE);
        self.metricsVisible(options.type !== TABLE);
        self.groupsVisible(options.type !== TABLE);
    },

    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    dispose: function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    }
};

function getDisplayIconClasses(type) {
    var classesArray;
    switch (type) {
        case PIE:
            classesArray = [
                {css:'fa fa-pie-chart', name:PIE},
                {css:'fa fa-bar-chart', name:BAR},
                {css:'fa fa-table', name:TABLE},
            ];
            break;

        case TREND:
            classesArray = [
                {css:'fa fa-area-chart', name:AREA_TREND},
                {css:'far fa-chart-area', name:STACKED_AREA_TREND},
                {css:'fa fa-bar-chart', name:BAR},
                {css:'fa fa-line-chart', name:LINE_TREND},
                {css:'fa fa-table', name:TABLE},
            ];
            break;

        default:
            classesArray = [
                {css:'fa fa-table', name:TABLE},
            ];
    }
    return classesArray;
}
function getTargetFromCategory(result, category) {
    // var appBaseUrl = _.includes(window.location.href, '#rooms') ? '#rooms' : '#historical2';
    let target = {
        call: '#historical2/endpoints/tabid/3',
        capacity: '',
        endpoint: '#historical2/endpoints/tabid/0',
        meeting: '#historical2/meetings/tabid/0',
        participant: '#historical2/meetings/tabid/2',
        schedulemeeting: '#rooms/bookings/tabid/0',
        scheduleroom: '#rooms/data/tabid/0',
        system: '#historical2/infrastructure/tabid/0',
        user: '#historical2/user/tabid/0',
        network: '#historical2/networks/tabid/0',
    }[category];
    if (target) {
        result.target = target;
    }
    return result;
}

// Look at the metric and determine which page to go to
function getLhsForClickCallbackUrl(metricColumn, groupColumn) {
    var result = _.set({}, 'lhs', metricColumn.replace(/^.*\./, ''));

    if (_.includes(metricColumn, 'fctcall.')) {
        result.target = '#historical2/endpoints/tabid/3';

    } else if (_.includes(metricColumn, 'fctmanageendpoint')) {
        result.target = '#historical2/endpoints/tabid/0';

    } else if (_.includes(metricColumn, 'fctunmanageendpoint')) {
        result.target = '#historical2/endpoints/tabid/1';

    } else if (metricColumn === 'fctmeetingpeak_day.meetingcurrentsystem') {
        if (groupColumn === 'dimsystem.systemtype') {
            result.target = '#historical2/sysconcurrentmeetingpeakbysystypecapacitydetails';

        } else if (groupColumn === 'dimsystem.systemname') {
            result.target = '#historical2/sysconcurrentmeetingpeakbysysnamecapacitydetails';
        }

        result.readOnly = true;

    } else if (metricColumn === 'fctmeetingpeak_system_day.meetingcurrentsystem' && groupColumn === 'dimsystemtype.systemtype') {
        result.target = '#historical2/systypeconcurrentmeetingpeakcapacitydetails';
        result.readOnly = true;

    } else if (_.includes(metricColumn, 'fctmeeting')) {
        result.target = '#historical2/meetings/tabid/0';

    } else if (_.includes(metricColumn, 'fctparticipant')) {
        result.target = '#historical2/meetings/tabid/2';

    } else if (_.includes(metricColumn, 'fctscheduleroom')) {
        result.target = '#rooms/data/tabid/0';

    } else if (_.includes(metricColumn, 'fctsystem')) {
        result.target = '#historical2/infrastructure/tabid/0';

    } else if ((_.includes(metricColumn, 'fctcapacity.')) && (groupColumn === 'dimsystem.systemname')) {
        result.target = '#historical2/capacitydetails';
        result.readOnly = true;

    } else if ((_.includes(metricColumn, 'fctclustercapacity.')) && (groupColumn === 'dimcluster.clustername')) {
        result.target = '#historical2/clustercapacitydetails';
        result.readOnly = true;

    } else if (_.includes(metricColumn, 'fcttrunkcapacity.') && (groupColumn === 'dimtrunk.name')) {
        result.target = '#historical2/trunkcapacitydetails';
        result.readOnly = true;

    } else if (_.includes(metricColumn, 'fctcallpeak_day.callcurrentsystem') && (groupColumn === 'dimendpointlocation.location')) {
        result.target = '#historical2/concurrentcallscapacitydetails';
        result.readOnly = true;

    } else if (_.includes(metricColumn, 'fctcallpeak_day.callcurrentbandwidth') && (groupColumn === 'dimendpointlocation.location')) {
        result.target = '#historical2/concurrentbandwidthcapacitydetails';
        result.readOnly = true;

    } else {
        result.target = '';
    }

    if (!groupColumn || (groupColumn === '(no grouping)')) {
        result.groupFilter = '';

    } else {
        result.groupFilter = groupColumn;
        result.op = '=';
    }

    return result;
}

function getSelectedDisplayIconClass(selectedDisplayType) {
    var selectedIconClass;
    switch (selectedDisplayType) {
        case AREA_TREND:
            selectedIconClass = 'fa fa-area-chart';
            break;
        case STACKED_AREA_TREND:
            selectedIconClass = 'far fa-chart-area';
            break;

        case BAR:
        case BAR_TREND:
            selectedIconClass = 'fa fa-bar-chart';
            break;

        case LINE_TREND:
            selectedIconClass = 'fa fa-line-chart';
            break;

        case PIE:
            selectedIconClass = 'fa fa-pie-chart';
            break;

        case TABLE:
            selectedIconClass = 'fa fa-table';
            break;
    }
    return selectedIconClass;
}

export default { template: templateMarkup, viewModel: FlexiPanelWidget };
